import React from 'react';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import { Box, Card, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import fullscriptIcon from '../../../static/fullscriptIcon.png';
import NicoleSmall from '../../../static/NicoleSmall.png';

const Circle = styled(Box)`
  width: 16.78px;
  height: 16.78px;
  border-radius: 50%;

  background: #ffffff;
  border: 1px solid #15d89d;
  margin-right: 10px;
`;

const ModalInner = styled(Flex)`
  max-width: 600px;
  width: 100%;
  max-height: 700px;
  overflow-y: auto;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const ToDoEntry = ({ text, onClick, isLoading, disabled, children }) => {
  return (
    <Flex alignItems={'center'} style={{ cursor: !isLoading && !disabled ? 'pointer' : '' }} mt="16px" onClick={onClick}>
      {!isLoading && !children && <Circle />}
      <Flex alignItems={'center'} flex={1}>
        {children}
        <Text fontSize={'14px'} flex={1} fontWeight="300" color={disabled ? 'grey' : ''}>
          {text}
        </Text>
      </Flex>
      {!isLoading && (
        <svg style={{ marginLeft: '10px' }} width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.8743 7.71726L1.79342 13.6516C1.59874 13.8401 1.28392 13.8401 1.08924 13.6516L0.269063 12.8577C0.074375 12.6692 0.074375 12.3645 0.269063 12.1761L5.17767 7.37644L0.269063 2.57682C0.074375 2.38836 0.074375 2.08362 0.269063 1.89517L1.08924 1.10125C1.28392 0.91279 1.59874 0.91279 1.79342 1.10125L7.8743 7.03561C8.06899 7.22407 8.06899 7.52881 7.8743 7.71726Z"
            fill="#354E79"
          />
        </svg>
      )}
    </Flex>
  );
};

const CardWrap = styled(Card)`
  width: 100%;
  flex: initial;
  padding: 12px;
  border-radius: 10px;
  @media screen and (max-width: 1300px) {
    padding-left: 20px;
    padding-right: 20px;
    background-color: transparent;
    box-shadow: initial;
    margin-top: 32px;
  }
`;

const Title = styled(Text)`
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const TitleMobile = styled(Heading)`
  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const ToDo = ({ history, analytics, client, canFullscript, canChat }) => {
  return (
    <>
      {!!canFullscript && (
        <CardWrap mb="20px">
          <Flex flexDirection={'column'}>
            <Title>Review your treatment plan</Title>
            <TitleMobile>Review your treatment plan</TitleMobile>

            <ToDoEntry
              text={'Review on Fullscript'}
              onClick={() => {
                window.open('https://us.fullscript.com/login', '_blank');
              }}
            >
              <img alt="" src={fullscriptIcon} style={{ marginRight: '10px' }} width={'26px'} />
            </ToDoEntry>
          </Flex>
        </CardWrap>
      )}
      {!!canChat && (
        <CardWrap mb="20px">
          <Flex flexDirection={'column'}>
            <Title>Chat with your care team</Title>
            <TitleMobile>Chat with your care team</TitleMobile>

            <ToDoEntry
              text={'Message your provider'}
              onClick={() => {
                history.push({
                  pathname: `/programs/gut-reset-communicator`,
                });
              }}
            >
              <img alt="" src={NicoleSmall} style={{ marginRight: '10px' }} width={'26px'} />
            </ToDoEntry>
          </Flex>
        </CardWrap>
      )}
      <CardWrap mb="20px">
        <Flex flexDirection={'column'}>
          <Title>Upload GI microbiome labs</Title>
          <TitleMobile>Upload GI microbiome labs</TitleMobile>

          <ToDoEntry
            text={'Upload your results'}
            onClick={() => {
              history.push('/uploadGiLabResults');
            }}
          >
            <svg style={{ marginRight: '10px' }} width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24.362 18.0454C23.2972 19.35 21.9678 20.2275 20.5461 20.9592C17.1202 22.7225 13.5115 23.142 9.74675 22.3596C8.98145 22.2006 8.19952 22.1166 7.42254 22.0207C6.03312 21.8487 4.75387 21.3946 3.71009 20.446C2.52224 19.3663 1.67037 18.0364 1.09452 16.5386C-0.0304666 13.6119 -0.360443 10.6218 0.445296 7.55491C0.730539 6.46871 1.28944 5.51317 1.86711 4.55881C2.72531 3.14034 3.90265 2.04156 5.21708 1.08118C6.02979 0.487466 6.99998 0.25374 7.98583 0.152942C11.8338 -0.23961 15.6118 0.11286 19.2898 1.33372C19.9566 1.55508 20.6673 1.81729 21.19 2.25981C21.958 2.9327 22.6508 3.68712 23.2563 4.50981C24.3 5.88315 24.8703 7.48646 25.2301 9.16209C25.6141 10.9518 25.9303 12.7534 25.728 14.5954C25.586 15.8843 25.0549 17.0272 24.362 18.0454Z"
                fill="#F5E4DD"
              />
              <g clipPath="url(#clip0_126_3253)">
                <path
                  d="M14.4561 12.526C15.0964 12.526 15.7104 12.2717 16.1631 11.819M14.4561 12.526C13.8158 12.526 13.2018 12.2717 12.749 11.819M14.4561 12.526V14.3366M16.1631 11.819C16.6159 11.3662 16.8702 10.7522 16.8702 10.1119M16.1631 11.819L17.4433 13.0991M16.8702 10.1119C16.8702 9.47164 16.6159 8.8576 16.1631 8.40486M16.8702 10.1119H18.6808M16.1631 8.40486C15.7104 7.95212 15.0964 7.69778 14.4561 7.69778M16.1631 8.40486L17.4433 7.12381M14.4561 7.69778C13.8158 7.69778 13.2018 7.95212 12.749 8.40486M14.4561 7.69778V5.88718M12.749 8.40486C12.2963 8.8576 12.042 9.47164 12.042 10.1119M12.749 8.40486L11.4689 7.12381M12.042 10.1119C12.042 10.7522 12.2963 11.3662 12.749 11.819M12.042 10.1119H10.2314M12.749 11.819L11.4689 13.0991M14.0543 5.88718H14.8587M17.1589 6.83944L17.7286 7.40905M18.6808 9.70926V10.5137M17.7286 12.8148L17.1589 13.3835M14.8587 14.3366H14.0543M11.7532 13.3835L11.1845 12.8148M10.2314 10.5137V9.70926M11.1845 7.40905L11.7532 6.83944"
                  stroke="#EBB6A7"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.39215 21.0068C9.44222 19.8919 9.68526 18.7941 10.1105 17.7622C13.7021 18.3579 19.9035 16.3577 21.7637 12.6382C24.2518 7.65778 19.9157 1.46678 14.19 2.42078C12.4751 2.71066 10.8772 3.47976 9.58086 4.63924C8.49467 3.61219 8.45032 3.22259 7.56328 1.43982M3.11679 1.43982C3.86548 3.95189 5.15891 6.26796 6.90496 8.22305C5.69094 10.7711 5.49353 13.5714 6.45014 15.422C5.51789 17.14 5.00254 19.053 4.94565 21.0068"
                  stroke="#344F7A"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_126_3253">
                  <rect width="20.8715" height="20.8715" fill="white" transform="translate(2.36282 0.787598)" />
                </clipPath>
              </defs>
            </svg>
          </ToDoEntry>
        </Flex>
      </CardWrap>
    </>
  );
};

export default withApollo(withRouter(ToDo));
